var modules_2b902d32 = {"container":"_1x5hfyt","alert":"_jblatu","type-success":"_16f4vfc","type-info":"_vjmnwz","type-warning":"_1ec43bb","type-error":"_zzn9hg"};
import "../../../assets/c-t3sLw_.css";

export { modules_2b902d32 as default };
//# sourceMappingURL=Notifications.module.less.js.map
